import { jwtDecode, JwtPayload } from 'jwt-decode';

export function isDecodedTokenExpired(token: JwtPayload) {
  return token.exp && token.exp < Date.now() / 1000;
}

export function isTokenExpired(token: string) {
  try {
    const decodedToken = jwtDecode(token);

    return isDecodedTokenExpired(decodedToken);
  } catch (error) {
    return true;
  }
}
